export const messages = {
  en: {
    feePrintPageManage: {
      search: {
        title: 'Search Conditions',
        pageId: 'Receipt ID',
        pageName: 'Name',
        state: 'Status',
        all: 'All',
        enabled: 'Enabled',
        disabled: 'Disabled'
      },
      list: {
        title: 'Receipt Template'
      },
      table: {
        pageId: 'Receipt ID',
        pageName: 'Name',
        communityId: 'Community ID',
        templateName: 'Receipt Page',
        state: 'Status',
        enabled: 'Enabled',
        disabled: 'Disabled',
        operation: 'Operation'
      },
      add: {
        title: 'Add Receipt Template',
        pageName: 'Name',
        pageNamePlaceholder: 'Please enter name',
        template: 'Receipt Page',
        templatePlaceholder: 'Please select receipt page',
        success: 'Add successfully'
      },
      edit: {
        title: 'Edit Receipt Template',
        pageName: 'Name',
        pageNamePlaceholder: 'Please enter name',
        template: 'Receipt Page',
        templatePlaceholder: 'Please select receipt page',
        success: 'Update successfully'
      },
      delete: {
        title: 'Delete Confirmation',
        confirmText: 'Are you sure to delete this receipt template?',
        success: 'Delete successfully'
      },
      validate: {
        pageNameRequired: 'Name is required',
        pageNameMaxLength: 'Name cannot exceed 128 characters',
        templateRequired: 'Receipt page is required',
        pageIdRequired: 'Receipt ID is required'
      },
      fetchError: 'Failed to fetch data'
    }
  },
  zh: {
    feePrintPageManage: {
      search: {
        title: '查询条件',
        pageId: '收据ID',
        pageName: '名称',
        state: '状态',
        all: '全部',
        enabled: '启用',
        disabled: '停用'
      },
      list: {
        title: '收据模板'
      },
      table: {
        pageId: '收据ID',
        pageName: '名称',
        communityId: '园区ID',
        templateName: '收据页面',
        state: '状态',
        enabled: '启用',
        disabled: '停用',
        operation: '操作'
      },
      add: {
        title: '添加收据模板',
        pageName: '名称',
        pageNamePlaceholder: '请输入名称',
        template: '收据页面',
        templatePlaceholder: '请选择收据页面',
        success: '添加成功'
      },
      edit: {
        title: '修改收据模板',
        pageName: '名称',
        pageNamePlaceholder: '请输入名称',
        template: '收据页面',
        templatePlaceholder: '请选择收据页面',
        success: '修改成功'
      },
      delete: {
        title: '删除确认',
        confirmText: '确定删除该收据模板吗？',
        success: '删除成功'
      },
      validate: {
        pageNameRequired: '名称不能为空',
        pageNameMaxLength: '名称不能超过128个字符',
        templateRequired: '收据页面不能为空',
        pageIdRequired: '收据ID不能为空'
      },
fetchError: '获取数据失败'
    }
  },
  'zh-TW': {
    feePrintPageManage: {
      search: {
        title: '查詢條件',
        pageId: '收據ID',
        pageName: '名稱',
        state: '狀態',
        all: '全部',
        enabled: '啟用',
        disabled: '停用'
      },
      list: {
        title: '收據模板'
      },
      table: {
        pageId: '收據ID',
        pageName: '名稱',
        communityId: '小區ID',
        templateName: '收據頁面',
        state: '狀態',
        enabled: '啟用',
        disabled: '停用',
        operation: '操作'
      },
      add: {
        title: '添加收據模板',
        pageName: '名稱',
        pageNamePlaceholder: '請輸入名稱',
        template: '收據頁面',
        templatePlaceholder: '請選擇收據頁面',
        success: '添加成功'
      },
      edit: {
        title: '修改收據模板',
        pageName: '名稱',
        pageNamePlaceholder: '請輸入名稱',
        template: '收據頁面',
        templatePlaceholder: '請選擇收據頁面',
        success: '修改成功'
      },
      delete: {
        title: '刪除確認',
        confirmText: '確定刪除該收據模板嗎？',
        success: '刪除成功'
      },
      validate: {
        pageNameRequired: '名稱不能為空',
        pageNameMaxLength: '名稱不能超過128個字符',
        templateRequired: '收據頁面不能為空',
        pageIdRequired: '收據ID不能為空'
      },
      fetchError: '獲取數據失敗'
    }
  }
}